import { Role } from '@precon-tools-suite-by-shared/js-precon-rbac';
import type { AbilityContext } from '@precon-tools-suite-by-shared/shared-auth-js-ability-checks';
import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/access-restricted',
        name: 'access-restricted',
        component: () => import('../pages/AccessRestricted.vue'),
        meta: {
            layout: 'access-denied',
        },
        props: true,
    },
    {
        path: '/',
        name: 'welcome',
        component: () => import('../pages/Welcome.vue'),
        meta: {
            layout: 'landing',
        },
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('../pages/Help.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../pages/Dashboard.vue'),
        meta: {
            layout: 'app',
            requiresAuth: true,
            policy: (context: AbilityContext) => {
                const ability = (context: AbilityContext) => {
                    return context.hasAnyRole(
                        Role.DEV,
                        Role.ACCESS_ADMIN,
                        Role.MAINTAINER,
                        Role.SUPER
                    );
                };

                return context.check(ability);
            },
        },
    },
] satisfies RouteRecordRaw[];
